import { Box, Typography } from "@mui/material";
import "./index.css";

const YFSLabelVerifications = ({ editMode }) => {
  return (
    <Box
      sx={{
        mb: 2,
        mt: 3,
        p: 2,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      className="yfs-verif-container"
    >
      <Typography
        variant="caption"
        sx={{ color: "#203669", marginBottom: "5px" }}
      >
        Verification
      </Typography>
      <div
        style={{
          marginBottom: "5px",
          width: editMode ? "80%" : "80%",
          height: "0.5px",
          backgroundColor: "#173567",
        }}
      ></div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginTop: "5px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 15,
              height: 15,
              borderRadius: "50%",
              bgcolor: "#8CC63F",
              mr: 1,
            }}
          />
          <Typography variant="caption" sx={{ mr: 2, color: "#203669" }}>
            Third party
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 15,
              height: 15,
              borderRadius: "50%",
              bgcolor: "#F7931E",
              mr: 1,
            }}
          />
          <Typography variant="caption" sx={{ mr: 2, color: "#203669" }}>
            Supplier
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 15,
              height: 15,
              borderRadius: "50%",
              bgcolor: "#C1272D",
              mr: 1,
            }}
          />
          <Typography variant="caption" sx={{ color: "#203669" }}>
            Internal
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default YFSLabelVerifications;
